import { Literal } from "runtypes";
export const TEAMS = ["blue", "orange"];
export const StudentTeams = Literal("orange").Or(Literal("blue"));
export const Teams = StudentTeams.Or(Literal("staff")).Or(Literal("none"));
//# sourceMappingURL=teams.js.map
